export const TILE_SIZES = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
} as const;

export interface VisualFilterOption {
    id: string;
    alias?: string;
    count?: number;
    selected?: boolean;
}

export interface VisualFilter {
    id: string;
    options?: VisualFilterOption[];
    tileSize?: tileSizeType;
}

export type tileSizeType = (typeof TILE_SIZES)[keyof typeof TILE_SIZES];
